import React from 'react';

import { BuildIconImage } from '../utils';

const IconErrorScreen = (props) => <BuildIconImage {...props} src="error-screen.svg" alt="Error Screen icon" preload />;

export default IconErrorScreen;
